import { Injectable, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export enum OutputValues {
  HEALTHCHECK = 'HEALTHCHECK',
  REFRESH = 'REFRESH',
  DATA_ACTUALIZATION = 'DATA_ACTUALIZATION'
}

export interface ParentResponse {
  operation: string;
  response: any;
}

export interface ParentRequest {
  operation: string;
  request: any;
}

@Injectable({
    providedIn: 'root'
})
export class ParentCallerService {
    private defaultRequest: ParentRequest = {
      operation: '',
      request: {}
    };
    private defaultResponse: ParentResponse = {
      operation: '',
      response: {}
    };
    constructor() {}

    public callParentRequest: BehaviorSubject<ParentRequest> = new BehaviorSubject<ParentRequest>(this.defaultRequest);
    public getParentResponse: BehaviorSubject<ParentResponse> = new BehaviorSubject<ParentResponse>(this.defaultResponse);

    public checkOperationValues(operation: string) {
      const enumIndex = Object.values(OutputValues) as [string];
      return enumIndex.includes(operation);
    }
    public callParent(request: ParentRequest) {
      if (!this.checkOperationValues(request.operation)) {
        return false;
      }
      this.callParentRequest.next(request);
    }

    public sendResponse(response: ParentResponse) {
      if (!this.checkOperationValues(response.operation)) {
        return false;
      }
      this.getParentResponse.next(response);
    }
}

